module.exports = __webpack_public_path__ + "static/media/T3.05ed0216.jpg";